import { debugLogger } from './debugLogger';

export function setupGlobalErrorHandlers() {
  window.addEventListener('error', (event) => {
    debugLogger.group('🔴 Global Error Handler - JavaScript Error');
    debugLogger.error('Message:', event.message);
    debugLogger.error('Filename:', event.filename);
    debugLogger.error('Line:Column:', `${event.lineno}:${event.colno}`);
    debugLogger.error('Error object:', event.error);
    debugLogger.error('Stack:', event.error?.stack);
    debugLogger.groupEnd();
  });

  window.addEventListener('unhandledrejection', (event) => {
    debugLogger.group('🔴 Global Error Handler - Unhandled Promise Rejection');
    debugLogger.error('Reason:', event.reason);
    debugLogger.error('Promise:', event.promise);
    if (event.reason?.stack) {
      debugLogger.error('Stack:', event.reason.stack);
    }
    debugLogger.groupEnd();
  });

  debugLogger.log('✅ Global error handlers initialized');
}

